module.exports = __webpack_public_path__ + "images/emoji/church.8a1b2c6fe1e30f4cb557.png";